export const creditorFlags = Object.freeze({
  WITH_CREDITOR: 'With',
  WITHOUT_CREDITOR: 'Without',
  ALL_CREDITORS: 'All',
});
